import { transition } from './shared';
/**
 * Generator for customizations for split buttons.
 */
export const actionButtonStyles = (theme) => ({
    splitButtonMenuButton: {
        background: 'transparent',
        color: theme.semanticColors.inputText,
    },
    root: {
        color: theme.semanticColors.inputText,
        transition,
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
            inset: '0px',
            margin: '2px',
        },
    },
    rootChecked: {
        color: theme.semanticColors.inputText,
        border: `1px outset ${theme.palette.blackTranslucent40}`,
    },
    rootCheckedHovered: {
        color: theme.palette.accent,
        border: `1px outset ${theme.palette.neutralPrimary}`,
    },
    iconChecked: {
        color: theme.palette.accent,
    },
});
